module.exports = __webpack_public_path__ + "static/media/mapiq.a03bcbfe.svg";